import ExpenseModal from "./ExpenseModal";
export default ExpenseModal;